import React from 'react';
import styled, { css } from 'styled-components/macro';
/**
 * Layout utilizado en todas las vistas para organizar los distintos componentes
 * que forman cada página
 */

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  @-moz-document url-prefix() {
    @media print {
      display:block;
      }
  }
`;

export const MidLayout = styled.main`
  display: flex;
  width: 100%;
  @media (max-width: 1024px) {
    padding-top: ${({ esHistorico }) => (esHistorico ? 0 : '60px')};
    flex-wrap: wrap;
  }
  @media (max-width: 768px) {
    padding-top: ${({ esHistorico }) => (esHistorico ? 0 : '50px')};
  }
  @media print {
    display:block;
    }
`;

export const CajaIzq = styled(({ width, ...rest }) => <section {...rest} />)`
  display: flex;
  flex-flow: column nowrap;
  order: 2;
  flex: 0 0 ${({ width }) => width};
  //background-color: #fff;
  @media (max-width: 1024px) {
    flex: 1 0 80%;
  }
  @media print {
    width: 100%;
    @media print {
      display:block;
      height: 100%;
      page-break-after: always;
      }
    }
`;

const Section = ({ width, page, tipoEst, ...rest }) => <section {...rest} />;
export const CajaDch = styled(Section)`
  height: 100%;
  max-width: ${({ width }) => width};
  width: ${({ width }) => width};
  flex: 0 0 auto;
  order: 2;
  margin-left: ${({tipoEst})=> tipoEst == 'C' ? '40px': '0'};
  @media (max-width: 1024px) {
    flex: 1 0 100%;
    order: 1;
    max-width: 100%;
    position: static;
  }
  @media print {
    width: 100%;
    max-width: 100%;
    display:block;
    position: relative;
    }
`;
